import { Chip, type ChipProps, styled } from '@mui/material';

const CustomizedChip = styled(Chip)<ChipProps>(({ theme, size, color = theme.palette.primary.main }) => {
    return {
        backgroundColor: theme.palette.getContrastText(color),
        color: `${color} !important`,
        fontSize: size === 'small' ? theme.typography.caption.fontSize : theme.typography.subtitle2.fontSize,
        fontWeight: 'bold',
        width: 'fit-content',
        height: size === 'small' ? '18px' : '24px',
        padding: size === 'small' ? '0 2px' : '0 4px',
    };
});

const LabelBadge = (chipProps: ChipProps) => {
    return <CustomizedChip {...chipProps} />;
};

export default LabelBadge;
